export const resources = {
	ru: {
		openAll: "Посмотреть рекламу, пока драконы вылупляются?",
		openMode: "Посмотреть рекламу, чтобы найти тройняшек?",
		yes: "Да",
		no: "Нет",
	},
	en: {
		openAll: "Watch an ad while the dragons are hatching?",
		openMode: "Watch an ad to find the triplets?",
		yes: "Yes",
		no: "No",
	},
	tr: {
		openAll: "Ejderhalar yumurtadan çıkarken bir reklam izlemek ister misiniz?",
		openMode: "Üçüzleri bulmak için bir reklam izlemek ister misiniz?",
		yes: "Evet",
		no: "Hayır",
	},
};
